export const terms = {
  backToHome: "Back to home",
  title: "Terms and Conditions",
  lastUpdated: "Last updated: January 2025",
  sections: {
    introduction: {
      title: "1. Company Identification and Scope",
      paragraph1: "These terms and conditions apply to all sales and deliveries of business data by NovaVenture Group BV, located at Krommestraat 48, 2830 Blaasveld, Belgium, with company number 1006303437 and VAT number BE1006303437.",
      paragraph2: "By placing an order or using our services, you fully and unconditionally accept these terms and conditions. Deviating conditions from the buyer do not apply unless expressly accepted in writing by NovaVenture Group BV."
    },
    services: {
      title: "2. Nature of Services",
      intro: "NovaVenture Group BV sells business data in Excel format for B2B purposes. The delivered data includes only:",
      items: [
        "Company names of businesses",
        "Landline telephone numbers (no mobile numbers)",
        "Complete business addresses",
        "VAT numbers and company registration numbers"
      ],
      outro: "We do not process names of natural persons, personal email addresses, or other sensitive personal data. All data originates from publicly accessible online sources where companies have published their information themselves."
    },
    usage: {
      title: "3. Permitted Use",
      intro: "The delivered business data may only be used for:",
      items: [
        "Legitimate business prospecting in accordance with applicable legislation",
        "B2B marketing and commercial contact",
        "Market research and business intelligence",
        "Internal business purposes within your organization"
      ]
    },
    prohibited: {
      title: "4. Prohibited Use",
      intro: "The buyer is expressly prohibited from:",
      items: [
        "Using the data for spam or illegal marketing practices",
        "Reselling, renting, or redistributing the data without prior written consent from NovaVenture Group BV",
        "Using the data for purposes that violate GDPR or other applicable legislation",
        "Combining the data with other databases without permission",
        "Making unwanted or aggressive contact that could damage the reputation of NovaVenture Group BV"
      ]
    },
    intellectualProperty: {
      title: "5. Intellectual Property",
      paragraph1: "All intellectual property rights relating to the databases, structure, selection, and composition of the data remain the property of NovaVenture Group BV at all times.",
      paragraph2: "The buyer acquires only a non-exclusive, non-transferable right to use the purchased data in accordance with these terms and conditions. Reverse engineering, decompilation, or other attempts to discover the underlying structure or methodology are prohibited."
    },
    disclaimer: {
      title: "6. Disclaimer and No Warranties",
      intro: "NovaVenture Group BV delivers the business data 'as is' without any warranty. Specifically:",
      items: [
        "We do not guarantee the completeness of the data",
        "We do not guarantee the accuracy or timeliness of all data",
        "Business data may be outdated due to company relocations, bankruptcies, or other changes",
        "We are not responsible for changes in data after delivery",
        "The buyer is responsible for verifying data if necessary"
      ],
      outro: "While we strive for maximum quality and timeliness, we cannot provide absolute guarantees regarding publicly available business information."
    },
    liability: {
      title: "7. Limitation of Liability",
      intro: "The liability of NovaVenture Group BV is limited as follows:",
      items: [
        "Our total liability is limited to a maximum of the invoice amount of the relevant purchase",
        "We are not liable for indirect damage, consequential damage, lost profits, or loss of revenue",
        "We are not liable for damage resulting from incorrect or unlawful use of the data by the buyer",
        "We are not liable for third-party claims arising from the buyer's use of the data"
      ],
      outro: "This limitation of liability does not apply in case of intent or gross negligence by NovaVenture Group BV."
    },
    payment: {
      title: "8. Payment and Invoicing",
      intro: "Payment terms:",
      items: [
        "Invoices are payable within 14 days of invoice date, unless otherwise agreed",
        "In case of late payment, we are entitled to charge interest of 10% per year",
        "In case of non-payment after reminder, all outstanding invoices become immediately due",
        "All prices are exclusive of VAT, unless expressly stated otherwise",
        "Collection costs and legal costs are borne by the buyer in case of default"
      ]
    },
    termination: {
      title: "9. Termination and Suspension",
      intro: "NovaVenture Group BV reserves the right to:",
      items: [
        "Immediately terminate delivery in case of breach of these terms",
        "Suspend access to services in case of suspected abuse",
        "Cancel pending orders without refund in case of prohibited use",
        "Take legal action in case of serious violations"
      ],
      outro: "In case of termination due to buyer's default, the payment obligation remains fully in effect."
    },
    law: {
      title: "10. Applicable Law and Competent Court",
      paragraph1: "These terms and conditions and all agreements between NovaVenture Group BV and the buyer are exclusively governed by Belgian law.",
      paragraph2: "All disputes arising from or related to these terms or their execution shall be submitted to the competent courts of the Antwerp district, Mechelen division, unless mandatory law provides otherwise."
    },
    dataProtection: {
      title: "11. Data Protection and GDPR Compliance",
      paragraph1: "The buyer acknowledges that the purchased data consists exclusively of publicly available business data and not personal data within the meaning of GDPR.",
      paragraph2: "If the buyer uses the data in a manner that does fall under GDPR, the buyer is solely responsible for compliance with all applicable data protection legislation. The buyer indemnifies NovaVenture Group BV against all claims arising from this."
    },
    changes: {
      title: "12. Changes to Terms",
      content: "NovaVenture Group BV reserves the right to modify these terms and conditions. Changes take effect after publication on our website. For already concluded agreements, the terms applicable at the time of order remain in effect."
    },
    severability: {
      title: "13. Severability",
      content: "If any provision of these terms and conditions proves to be void or unenforceable, the remaining provisions remain fully in effect. The void provision shall be deemed replaced by a valid provision that corresponds as closely as possible to the intention of the original provision."
    },
    contact: {
      title: "14. Contact Information",
      intro: "For questions about these terms and conditions or our services:",
      company: "NovaVenture Group BV",
      address: "Address",
      phone: "Phone",
      email: "Email",
      businessNumber: "Company number",
      vatNumber: "VAT number"
    }
  },
  footer: {
    copyright: "© 2025 NovaVenture Group BV. All rights reserved."
  }
};